/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'inferno-redux';
// actions used to manipulate application state
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import UserDataCollection from 'components/content/userdatacollection/userdatacollection';
import { setTotalFrameCount, advanceFrame, getUDCSettings, deactivateContents, setUniqueState } from 'redux/actions/content_status';



/* ========== ~~~~~~~~~~ USER DATA COLLECTION: PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ contentStatus, settings, sessionStatus }, { contentId }) => ({
    isPubPortalPreview: settings.embedSettings.isPubPortalPreview,
    embedUUID: settings.embedSettings.embedUUID,
    userId: sessionStatus.userInfo.userId !== undefined ? sessionStatus.userInfo.userId : null,
    isActive: contentStatus[contentId]['status'] === 'active',
    dataFetchingPermitted: sessionStatus.dataFetchingPermitted,
    dmpCallsEnabled: sessionStatus.dmpCallsEnabled,
    contentSignature: contentStatus[contentId].uniqueState.contentSignature,
    contentProperties: contentStatus[contentId].uniqueState.contentProperties,
    phase: contentStatus[contentId].uniqueState.phase,
    backgroundImageURL: !!contentStatus[contentId].uniqueState.contentProperties ?
        contentStatus[contentId].uniqueState.contentProperties.backgroundImageURL : null,
    backgroundColor: !!contentStatus[contentId].uniqueState.contentProperties ?
        contentStatus[contentId].uniqueState.contentProperties.backgroundColor : null,
});

// map actions
const mapDispatchToProps = dispatch => ({
    setTotalFrameCount: (contentId, totalFrameCount) => dispatch(setTotalFrameCount(contentId, totalFrameCount)),
    advanceFrame: contentId => dispatch(advanceFrame(contentId)),
    getUDCSettings: (embedUUID, contentId, cookieId, isPubPortalPreview) =>
        dispatch(getUDCSettings(embedUUID, contentId, cookieId, isPubPortalPreview)),
    setUniqueState: (contentId, state) => dispatch(setUniqueState(contentId, state)),
    deactivateContents: contentIds => dispatch(deactivateContents(contentIds))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
// will be utilized from any component that wants to incorporate "Content" component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserDataCollection);
